import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogin = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_892_18510",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_892_18510)",
		children: /* @__PURE__ */ _jsx("path", { d: "M11.8846 21V19.5H18.5961C18.673 19.5 18.7436 19.468 18.8077 19.4039C18.8718 19.3398 18.9038 19.2692 18.9038 19.1923V5.3077C18.9038 5.23077 18.8718 5.16024 18.8077 5.09613C18.7436 5.03202 18.673 4.99997 18.5961 4.99997H11.8846V3.5H18.5961C19.1012 3.5 19.5288 3.675 19.8788 4.025C20.2288 4.375 20.4038 4.80257 20.4038 5.3077V19.1923C20.4038 19.6974 20.2288 20.125 19.8788 20.475C19.5288 20.825 19.1012 21 18.5961 21H11.8846ZM10.6154 16.5192L9.57699 15.4346L12.0116 13H3.59619V11.5H12.0116L9.57699 9.0654L10.6154 7.98082L14.8846 12.25L10.6154 16.5192Z" })
	})]
});
export default SvgLogin;
